import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import NavbarComponent from './components/NavbarComponent'



function App() {
  return (
    <div className="App">
    <NavbarComponent />
  </div>
  );
}

export default App;